import React from 'react'
import PropTypes from 'prop-types'

import { COMING_SOON_IMAGE } from 'Defaults'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import { ListingV2 } from 'Pages'
import { appendImageTimestamp } from 'Utils/listingUtils'
import PreconCardDetail from '../PreconCardDetail'
import PreconMobileCard from '../PreconMobileCard'

import {
  _CardContainer,
  _PreconListing,
  _InnerContainerFlex,
  _ListingImg,
} from './styles'

export const TEST_IDS = {
  PRINT_BTN: 'printBtn',
  HIDE_SHOW_ICON: 'hideShowIconContainer',
}

const FLOORPLAN = 'Floorplan'

const PreconCard = ({
  listing,
}) => {
  const {
    sqft_Max: sqftMax,
    sqft_Min: sqftMin,
    bathrooms: baths,
    sqft,
    asking_price: askingPrice,
    address,
    title,
    mls_number: mlsNumber,
    url,
    photo_base_url: imgSrc,
    photo_version: photoVersion,
    property_type: propertyType,
    maintenance_fee: maintFee,
    bed_type: bedType,
  } = listing || {}

  const width = 320
  const height = 240
  const isFloorplan = propertyType === FLOORPLAN
  return (
    <_PreconListing
      to={'/' + url}
      openNewTab
      alt={`${propertyType} at` + address}
      mobileModalChildren={
        // eslint-disable-next-line react/no-unstable-nested-components
        ({ closeModalPage }) => (
          <ListingV2
            listingId={listing?.id}
            modalListingData={listing}
            closeModalPage={closeModalPage}
          />
        )
      }
      mobileModalKey={`listingModal-${listing?.id}`}
    >
      <_CardContainer >
        <_InnerContainerFlex>
          <_ListingImg
            to={'/' + url}
            alt={`Link to ${propertyType} at` + address}
            mobileModalChildren={
              // eslint-disable-next-line react/no-unstable-nested-components
              ({ closeModalPage }) => (
                <ListingV2
                  listingId={listing?.id}
                  modalListingData={listing}
                  closeModalPage={closeModalPage}
                />
              )
            }
            mobileModalKey={`listingModal-${listing?.id}`}
          >
            <ImagePlaceholder
              src={appendImageTimestamp(`${imgSrc}${mlsNumber?.toLowerCase()}_1-320x240.jpg` || COMING_SOON_IMAGE, photoVersion)}
              defaultSrc={COMING_SOON_IMAGE}
              alt={`${propertyType} photo at ` + address}
              width={width}
              height={height}
              noLazy
            />
          </_ListingImg>
          <PreconMobileCard
            askingPrice={askingPrice}
            baths={baths}
            sqft={sqft}
            sqftMax={sqftMax}
            sqftMin={sqftMin}
            propertyType={propertyType}
            maintFee={maintFee}
            title={title}
            isFloorplan={isFloorplan}
            bedType={bedType}
          />
          <PreconCardDetail
            askingPrice={askingPrice}
            baths={baths}
            sqft={sqft}
            sqftMax={sqftMax}
            sqftMin={sqftMin}
            propertyType={propertyType}
            maintFee={maintFee}
            title={title}
            isFloorplan={isFloorplan}
            bedType={bedType}
          />
        </_InnerContainerFlex>
      </_CardContainer>
    </_PreconListing>
  )
}

PreconCard.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
    sqft_Max: PropTypes.number,
    sqft_Min: PropTypes.number,
    photo_base_url: PropTypes.string,
    photo_version: PropTypes.string,
    address: PropTypes.string,
    asking_price: PropTypes.string,
    bathrooms: PropTypes.number,
    sqft: PropTypes.number,
    title: PropTypes.string,
    street_address: PropTypes.string,
    bed_type: PropTypes.string,
    mls_number: PropTypes.string,
    maintenance_fee: PropTypes.number,
    property_type: PropTypes.string,
  }),
}

export default PreconCard
